import { useCallback } from 'react';
import {
  getGodOnboarding,
  updateGodOnboarding,
  createHouseCallable,
} from '../services/firebase/FunctionsService';

export function useGodOnboarding() {
  const load = useCallback(() => getGodOnboarding(), []);
  const patch = useCallback((partial: Record<string, boolean>) => updateGodOnboarding(partial), []);
  const createHouse = useCallback(
    (payload: { name: string; houseId?: string }) => createHouseCallable(payload),
    [],
  );
  return { load, patch, createHouse };
}
